export enum ReadBehavior {
    FULL_ON_EVERY_RUN,
    FULL_ON_FIRST_RUN_THEN_INCREMENTAL,
    INCREMENTAL_CHANGES_ONLY
}
